module.exports = __webpack_public_path__ + "img/btn_minus.149fceaf.svg";